import ActivityPanel from './components/ActivityPanel';
import MattersPanel from './components/MattersPanel';
import { MainPageWrapper } from '@/components/molecules/PageWrappers/MainPageWrapper';

const MattersExplorer = () => {
  return (
    <MainPageWrapper className="p-0">
      <div className="flex h-full w-full">
        <ActivityPanel />
        <MattersPanel />
      </div>
    </MainPageWrapper>
  );
};

export default MattersExplorer;
